<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div style="margin-top: 28px"></div>
    <div class="card-header pb-0 col-sm-12 d-flex">
      <div class="col-sm-12 col-xs-12">
        <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
          <h1 class="fw-bold page-title">
            {{ isEdit ? '구독 수정' : '구독 추가' }}
          </h1>
          <span class="pageDesc">{{ isEdit ? '구독 정보를 수정합니다.' : '새로운 구독을 등록합니다.' }}</span>
        </div>
      </div>
    </div>
    
    <div class="card-body px-0 pt-0 pb-2">
      <div class="card content-wrap-card col-sm-12 col-xs-12 form-card">
        <a-form
          ref="formRef"
          :model="form"
          layout="vertical"
          :rules="rules"
          @finish="handleSubmit"
        >
          <!-- 기본 정보 섹션 -->
          <div class="form-section">
            <h2 class="section-title">구독자 정보</h2>
            
            <div class="form-row">
              <a-form-item label="병원명" name="hospitalName" class="form-item">
                <div class="input-with-button">
                  <a-input v-model:value="form.hospitalName" placeholder="병원명을 입력하세요" />
                  <a-button type="primary" class="yellow-button search-button" @click="showSearchModal = true">
                    거래처 검색
                  </a-button>
                </div>
              </a-form-item>
              
              <a-form-item label="병원 유형" name="hospitalType" class="form-item">
                <a-select v-model:value="form.hospitalType" placeholder="병원 유형을 선택하세요">
                  <a-select-option value="DENT">치과</a-select-option>
                  <a-select-option value="OPH">안과</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            
            <div class="form-row">
              <a-form-item label="사업자등록번호" name="businessNumber" class="form-item">
                <a-input 
                  v-model:value="form.businessNumber" 
                  placeholder="사업자등록번호를 입력하세요"
                  @input="formatBusinessNumber" 
                />
              </a-form-item>
              
              <a-form-item label="개원일" name="openingDate" class="form-item">
                <a-date-picker 
                  v-model:value="form.openingDate" 
                  style="width: 100%"
                  format="YYYY-MM-DD"
                />
              </a-form-item>
            </div>
            
            <div class="form-row">
              <a-form-item label="주소" name="address" class="form-item-full">
                <a-input v-model:value="form.address" placeholder="주소를 입력하세요" />
              </a-form-item>
            </div>
          </div>
          
          <!-- 상품 정보 섹션 -->
          <div class="form-section">
            <h2 class="section-title">구독 상품 정보</h2>
            
            <div class="form-row">
              <a-form-item label="상품 선택" name="productId" class="form-item-full">
                <a-select 
                  v-model:value="form.productId" 
                  placeholder="센터플로우 상품을 선택하세요"
                  @change="handleProductChange"
                >
                  <a-select-option 
                    v-for="product in productList" 
                    :key="product.key" 
                    :value="product.key"
                  >
                    {{ product.productName }} ({{ product.priceIncludingVAT.toLocaleString() }}원)
                  </a-select-option>
                </a-select>
                <div class="product-info" v-if="productList.length === 0">
                  <a-alert type="info" message="센터플로우 상품이 등록되어 있지 않습니다. 먼저 상품 관리에서 센터플로우 상품을 등록해주세요." show-icon banner />
                  <div class="mt-2">
                    <a-button type="primary" class="yellow-button" @click="navigateToProductManagement">
                      상품 관리로 이동
                    </a-button>
                  </div>
                </div>
              </a-form-item>
            </div>
            
            <div class="form-row">
              <a-form-item label="설치비(1회성, VAT포함)" name="price" class="form-item">
                <a-input-number 
                  v-model:value="form.price" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  style="width: 100%"
                  :disabled="true"
                />
              </a-form-item>
              
              <a-form-item label="판매가(VAT포함)" name="priceIncludingVAT" class="form-item">
                <a-input-number 
                  v-model:value="form.priceIncludingVAT" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  style="width: 100%"
                  :disabled="true"
                />
              </a-form-item>
            </div>
            
            <div class="form-row">
              <a-form-item label="판매가(VAT제외)" name="priceExcludingVAT" class="form-item">
                <a-input-number 
                  v-model:value="form.priceExcludingVAT" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  style="width: 100%"
                  :disabled="true"
                />
              </a-form-item>
              
              <a-form-item label="할인율(%)" name="discountRate" class="form-item">
                <a-input-number 
                  v-model:value="form.discountRate" 
                  style="width: 100%"
                  :disabled="true"
                />
              </a-form-item>
            </div>
            
            <div class="form-row">
              <a-form-item label="상품 설명" name="productDescription" class="form-item-full">
                <a-textarea 
                  v-model:value="form.productDescription" 
                  :rows="3"
                  :disabled="true"
                />
              </a-form-item>
            </div>
          </div>
          
          <!-- 결제 카드 정보 섹션 -->
          <div class="form-section">
            <h2 class="section-title">결제 카드 정보 <span class="optional-label"></span></h2>
            
            <div class="form-row">
              <a-form-item label="카드번호" name="cardNumber" class="form-item-full">
                <div class="input-with-button">
                  <a-input 
                    v-model:value="form.cardNumber" 
                    placeholder="0000-0000-0000-0000" 
                    :maxlength="19"
                    @input="formatCardNumber"
                  />
                  <a-button 
                    type="primary" 
                    class="yellow-button search-button" 
                    @click="validateCard"
                    :loading="validatingCard"
                  >
                    카드유효성 검사
                  </a-button>
                </div>
                <div class="description-text">국내 신용카드 번호 16자리(또는 15자리)를 입력해주세요.</div>
              </a-form-item>
            </div>
            
            <div class="form-row">
              <a-form-item label="유효기간" name="cardExpiry" class="form-item">
                <div class="card-expiry-container">
                  <a-input 
                    v-model:value="form.cardExpiryMonth" 
                    placeholder="MM" 
                    :maxlength="2"
                    class="expiry-input"
                  />
                  <span class="expiry-separator">/</span>
                  <a-input 
                    v-model:value="form.cardExpiryYear" 
                    placeholder="YY" 
                    :maxlength="2"
                    class="expiry-input"
                  />
                </div>
              </a-form-item>
              
              <a-form-item label="생년월일(6자리) / 사업자번호(10자리)" name="birthDate" class="form-item">
                <a-input 
                  v-model:value="form.birthDate" 
                  placeholder="230131 또는 123-45-67890" 
                  :maxlength="12"
                  @input="formatBirthDate"
                />
                <div class="description-text">법인카드의 경우 사업자등록번호 10자리를 입력해주세요.</div>
              </a-form-item>
            </div>
            
            <div class="form-row">
              <a-form-item label="카드사" name="cardCompany" class="form-item-full">
                <a-select v-model:value="form.cardCompany" placeholder="카드 유효성 검사를 성공하면 카드사명이 자동 입력됩니다." :disabled="true">
                  <a-select-option value="SHINHAN">신한카드</a-select-option>
                  <a-select-option value="SAMSUNG">삼성카드</a-select-option>
                  <a-select-option value="HYUNDAI">현대카드</a-select-option>
                  <a-select-option value="BC">BC카드</a-select-option>
                  <a-select-option value="KB">KB국민카드</a-select-option>
                  <a-select-option value="WOORI">우리카드</a-select-option>
                  <a-select-option value="HANA">하나카드</a-select-option>
                  <a-select-option value="LOTTE">롯데카드</a-select-option>
                  <a-select-option value="NH">NH농협카드</a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          
          <!-- 계약 정보 섹션 -->
          <div class="form-section">
            <h2 class="section-title">계약 정보</h2>
            
            <div class="form-row">
              <a-form-item label="계약 시작일" name="contractStartDate" class="form-item">
                <a-date-picker 
                  v-model:value="form.contractStartDate" 
                  style="width: 100%"
                  format="YYYY-MM-DD"
                />
              </a-form-item>
              
              <a-form-item label="계약 종료일" name="contractEndDate" class="form-item">
                <a-date-picker 
                  v-model:value="form.contractEndDate" 
                  style="width: 100%"
                  format="YYYY-MM-DD"
                />
              </a-form-item>
            </div>
            
            <!-- 담당자 정보 섹션 -->
            <div class="manager-section">
              <div class="manager-header">
                <h3 class="manager-title">담당자 정보</h3>
                <a-button type="primary" class="yellow-button" size="small" @click="showManufacturerModal = true">
                  담당자 정보 불러오기
                </a-button>
              </div>
              
              <div class="form-row">
                <a-form-item label="담당자 이름" name="managerName" class="form-item">
                  <a-input v-model:value="form.managerName" placeholder="담당자 이름을 입력하세요" />
                </a-form-item>
                
                <a-form-item label="담당자 연락처" name="managerContact" class="form-item">
                  <a-input 
                    v-model:value="form.managerContact" 
                    placeholder="담당자 연락처를 입력하세요"
                    @input="formatMobileNumber"
                  />
                </a-form-item>
              </div>
              
              <div class="form-row">
                <a-form-item label="담당자 이메일" name="managerEmail" class="form-item-full">
                  <a-input v-model:value="form.managerEmail" placeholder="담당자 이메일을 입력하세요" />
                </a-form-item>
              </div>
            </div>
            
            <div class="form-row">
              <a-form-item label="비고" name="notes" class="form-item-full">
                <a-textarea 
                  v-model:value="form.notes" 
                  :rows="3"
                  placeholder="추가 정보나 비고사항을 입력하세요"
                />
              </a-form-item>
            </div>
          </div>
          
          <!-- 폼 제출 버튼 -->
          <div class="form-actions">
            <a-button @click="handleCancel">취소</a-button>
            <a-button type="primary" html-type="submit" :loading="submitting" class="yellow-button">
              {{ isEdit ? '수정하기' : '등록하기' }}
            </a-button>
          </div>
        </a-form>
      </div>
    </div>
    
    <!-- 거래처 검색 모달 -->
    <search-client-modal
      v-model:visible="showSearchModal"
      :init-data-load="true"
      search-type="HOSPITAL"
      @select-client="handleSelectClient"
      @close-modal="showSearchModal = false"
    />
    
    <!-- 제조사 검색 모달 (담당자 정보 불러오기용) -->
    <search-client-modal
      v-model:visible="showManufacturerModal"
      :init-data-load="true"
      search-type="MANUFACTURER"
      modalType="MANAGER"
      @select-client="handleSelectManufacturer"
      @close-modal="showManufacturerModal = false"
    />
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import subscriptionSkuApis from '../products/api';
import salesRecordsApis from '../api';
import dayjs from 'dayjs';
import SearchClientModal from './SearchClientModal.vue';

export default {
  name: 'UpsertSubscription',
  components: {
    SearchClientModal
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const internalInstance = getCurrentInstance();
    const globalProperties = internalInstance?.appContext.config.globalProperties;
    const formRef = ref(null);
    const submitting = ref(false);
    const productList = ref([]);
    const validatingCard = ref(false);
    
    // 수정 모드인지 확인
    const isEdit = computed(() => route.params.id !== undefined);
    
    // 폼 데이터
    const form = reactive({
      // 구독자 정보
      hospitalName: '',
      hospitalType: '',
      businessNumber: '',
      openingDate: null,
      address: '',
      hospitalId: '',
      
      // 상품 정보
      productId: undefined,
      price: 0,
      priceExcludingVAT: 0,
      priceIncludingVAT: 0,
      discountRate: 0,
      productDescription: '',
      
      // 계약 정보
      contractStartDate: null,
      contractEndDate: null,
      managerCompanyId: '',
      managerCompanyName: '',
      managerName: '',
      managerContact: '',
      managerEmail: '',
      notes: '',
      
      // 카드 정보 (현입력 중인 카드)
      cardNumber: '',
      cardExpiryMonth: '',
      cardExpiryYear: '',
      birthDate: '',
      cardCompany: undefined,
      isDefaultCard: true,
      isActiveCard: true,
    });
    
    // 카드 목록
    const cardInfos = ref([]);
    
    // 폼 유효성 검사 규칙
    const rules = {
      hospitalName: [{ required: true, message: '병원명을 입력해주세요', trigger: 'blur' }],
      hospitalType: [{ required: true, message: '병원 유형을 선택해주세요', trigger: 'change' }],
      businessNumber: [{ required: true, message: '사업자등록번호를 입력해주세요', trigger: 'blur' }],
      productId: [{ required: true, message: '상품을 선택해주세요', trigger: 'change' }],
      contractStartDate: [{ required: true, message: '계약 시작일을 선택해주세요', trigger: 'change' }],
      contractEndDate: [{ required: true, message: '계약 종료일을 선택해주세요', trigger: 'change' }],
      managerName: [{ required: true, message: '담당자 이름을 입력해주세요', trigger: 'blur' }],
      managerContact: [{ required: true, message: '담당자 연락처를 입력해주세요', trigger: 'blur' }],
      cardNumber: [{ required: false, message: '카드번호를 입력해주세요', trigger: 'blur' }],
      cardExpiryMonth: [{ required: false, message: '유효기간(월)을 입력해주세요', trigger: 'blur' }],
      cardExpiryYear: [{ required: false, message: '유효기간(년)을 입력해주세요', trigger: 'blur' }],
      birthDate: [{ required: false, message: '생년월일 6자리를 입력해주세요', trigger: 'blur' }],
      cardCompany: [{ required: false, message: '카드사를 선택해주세요', trigger: 'change' }]
    };
    
    // API 인스턴스 가져오기
    const apiHandler = () => {
      return subscriptionSkuApis(globalProperties?.$apiInstance, globalProperties?.$store);
    };
    
    const showToast = (type, message) => {
      if (globalProperties?.$message) {
        globalProperties.$message[type](message);
      } else {
        alert(message);
      }
    };
    
    // 상품 목록 로드
    const loadProductList = async () => {
      try {
        const params = {
          page: 1,
          limit: 100,
          productGroup: '센터플로우'
        };
        
        // 첫 번째 방법: subscription-skus 엔드포인트 사용
        await apiHandler().getSubscriptionProducts(
          params,
          (response) => {
            const { docs } = response.data;
            // 추가 필터링: productGroup이 "센터플로우"인 항목만 추출
            const filteredDocs = docs.filter(item => item.productGroup === '센터플로우');
            
            if (filteredDocs.length > 0) {
              productList.value = filteredDocs.map(mapProductData);
            } else {
              loadProductListAlternative();
            }
          },
          (error) => {
            loadProductListAlternative();
          }
        );
      } catch (error) {
        loadProductListAlternative();
      }
    };
    
    // 대체 방법: getSubscriptionProductsByGroup 사용
    const loadProductListAlternative = async () => {
      try {
        await apiHandler().getSubscriptionProductsByGroup(
          '센터플로우',
          (response) => {
            const products = response.data || [];
            
            if (products.length > 0) {
              productList.value = products.map(mapProductData);
            } else {
              loadProductListFallback();
            }
          },
          (error) => {
            loadProductListFallback();
          }
        );
      } catch (error) {
        loadProductListFallback();
      }
    };
    
    // 세 번째 방법: 목업 데이터 사용
    const loadProductListFallback = () => {
      // 목업 데이터 (실제 API가 잘 작동하지 않을 때 사용)
      const mockData = [
        {
          id: 'mock-id-1',
          productGroup: '센터플로우',
          productName: '센터플로우 베이직 패키지',
          price: 1500000,
          priceExcludingVAT: 270000,
          priceIncludingVAT: 297000,
          discountRate: 20,
          description: '센터플로우 기본 구독 패키지'
        },
        {
          id: 'mock-id-2',
          productGroup: '센터플로우',
          productName: '센터플로우 프로 패키지',
          price: 2500000,
          priceExcludingVAT: 450000,
          priceIncludingVAT: 495000,
          discountRate: 30,
          description: '센터플로우 프로페셔널 구독 패키지'
        }
      ];
      
      productList.value = mockData.map(mapProductData);
    };
    
    // 상품 데이터 매핑 함수
    const mapProductData = (item) => ({
      key: item.id || item._id,
      productGroup: item.productGroup || '',
      productName: item.productName || '',
      price: item.price || 0,
      priceExcludingVAT: item.priceExcludingVAT || 0,
      priceIncludingVAT: item.priceIncludingVAT || 0,
      discountRate: item.discountRate || 0,
      description: item.description || ''
    });
    
    // 상품 선택 시 이벤트 핸들러
    const handleProductChange = (value) => {
      const selectedProduct = productList.value.find(product => product.key === value);
      if (selectedProduct) {
        form.price = selectedProduct.price;
        form.priceExcludingVAT = selectedProduct.priceExcludingVAT;
        form.priceIncludingVAT = selectedProduct.priceIncludingVAT;
        form.discountRate = selectedProduct.discountRate;
        form.productDescription = selectedProduct.description;
      }
    };
    
    // 카드번호 포맷팅 함수
    const formatCardNumber = (e) => {
      let value = e.target.value.replace(/\D/g, '');
      let formattedValue = '';
      
      for (let i = 0; i < value.length; i++) {
        if (i > 0 && i % 4 === 0) {
          formattedValue += '-';
        }
        formattedValue += value[i];
      }
      
      form.cardNumber = formattedValue;
    };
    
    // 사업자번호 포맷팅 함수 (3-2-5 형식)
    const formatBusinessNumber = (e) => {
      let value = e.target.value.replace(/\D/g, '');
      let formattedValue = '';
      
      if (value.length > 0) {
        // 앞 3자리
        formattedValue = value.slice(0, 3);
        
        // 중간 2자리
        if (value.length > 3) {
          formattedValue += '-' + value.slice(3, 5);
          
          // 뒤 5자리
          if (value.length > 5) {
            formattedValue += '-' + value.slice(5, 10);
          }
        }
      }
      
      form.businessNumber = formattedValue;
    };
    
    // 생년월일/사업자번호 포맷팅 함수
    const formatBirthDate = (e) => {
      let value = e.target.value.replace(/\D/g, '');
      
      // 6자리 이하는 생년월일로 간주하고 그대로 유지 (하이픈 없음)
      if (value.length <= 6) {
        form.birthDate = value;
        return;
      }
      
      // 6자리 초과는 사업자번호로 간주하고 포맷팅 적용
      let formattedValue = '';
      
      // 앞 3자리
      formattedValue = value.slice(0, 3);
      
      // 중간 2자리
      if (value.length > 3) {
        formattedValue += '-' + value.slice(3, 5);
        
        // 뒤 5자리
        if (value.length > 5) {
          formattedValue += '-' + value.slice(5);
        }
      }
      
      // 최종 값 할당 (최대 10자리 숫자 + 2개 하이픈)
      form.birthDate = formattedValue;
    };
    
    // 모바일 번호 포맷팅 함수 (3-4-4 또는 3-3-4 형식)
    const formatMobileNumber = (e) => {
      let value = e.target.value.replace(/\D/g, '');
      let formattedValue = '';
      
      if (value.length > 0) {
        // 앞 3자리
        formattedValue = value.slice(0, 3);
        
        // 두 번째 그룹 (4자리 또는 3자리)
        if (value.length > 3) {
          // 010으로 시작하면 4-4 형식, 그 외에는 3-4 형식
          const isFormat344 = value.startsWith('010');
          const secondGroupLength = isFormat344 ? 4 : 3;
          
          formattedValue += '-' + value.slice(3, 3 + secondGroupLength);
          
          // 세 번째 그룹 (4자리)
          if (value.length > 3 + secondGroupLength) {
            formattedValue += '-' + value.slice(3 + secondGroupLength, 3 + secondGroupLength + 4);
          }
        }
      }
      
      form.managerContact = formattedValue;
    };
    
    // 검색 모달 상태
    const showSearchModal = ref(false);
    
    // 거래처 선택 핸들러
    const handleSelectClient = (client) => {
      // 병원명
      form.hospitalName = client.name;
      
      // hospital ID 설정
      form.hospitalId = client.id || client._id || '';
      
      // 사업자번호 설정 및 포맷팅 적용
      if (client.cNo) {
        // 먼저 하이픈 없는 형태로 저장
        form.businessNumber = client.cNo.replace(/-/g, '');
        // 포맷팅 함수 수동 호출
        formatBusinessNumber({ target: { value: form.businessNumber } });
      }
      
      // 주소 처리
      if (client.bizAddr) {
        form.address = client.bizAddr;
      } else if (client.addrOne || client.addrTwo || client.addrThree) {
        let fullAddress = '';
        
        // 기본 주소 부분 구성
        const addressParts = [client.addrOne, client.addrTwo, client.addrThree].filter(Boolean);
        if (addressParts.length > 0) {
          fullAddress = addressParts.join(' ');
        }
        
        // 상세 주소 추가 (있는 경우)
        if (client.addrDetail) {
          if (client.dongInfo || client.companyInfo) {
            fullAddress += ` (${[client.dongInfo, client.companyInfo].filter(Boolean).join(', ')})`;
          }
          fullAddress += ` ${client.addrDetail}`;
        } else if (client.dongInfo || client.companyInfo) {
          fullAddress += ` (${[client.dongInfo, client.companyInfo].filter(Boolean).join(', ')})`;
        }
        
        form.address = fullAddress;
      } else if (client.roadAddress && client.roadAddress.addressName) {
        form.address = client.roadAddress.addressName;
      }
      
      // 병원 유형 처리
      if (client.medicalDept && client.medicalDept.includes('DENT')) {
        form.hospitalType = 'DENT';
      } else if (client.medicalDept && client.medicalDept.includes('OPH')) {
        form.hospitalType = 'OPH';
      }
      
      // 담당자 정보가 있는 경우
      if (client.empInfo) {
        form.managerName = client.empInfo.empName || '';
        
        // 모바일 번호 설정 (포맷팅 함수가 적용됨)
        if (client.empInfo.empMobile) {
          form.managerContact = client.empInfo.empMobile.replace(/-/g, '');
          formatMobileNumber({ target: { value: form.managerContact } });
        }
      }
      
      // 개원일 처리 (있는 경우)
      if (client.openDate) {
        try {
          form.openingDate = dayjs(client.openDate);
        } catch (e) {
          console.error('개원일 변환 오류:', e);
        }
      }
      
      showSearchModal.value = false;
    };
    
    // 폼 제출 핸들러
    const handleSubmit = async () => {
      submitting.value = true;
      
      try {
        // 병원 유형 변환 (한글 값으로 변환)
        let hospitalTypeValue = form.hospitalType;
        if (form.hospitalType === 'DENT') {
          hospitalTypeValue = '치과';
        } else if (form.hospitalType === 'OS') {
          hospitalTypeValue = '정형외과';
        } else if (form.hospitalType === 'OPH') {
          hospitalTypeValue = '안과';
        }
        
        // 서버에 전송할 데이터 구성
        const subscriptionData = {
          hospitalName: form.hospitalName,
          hospitalType: hospitalTypeValue,
          businessNumber: form.businessNumber.replace(/-/g, ''),
          hospitalId: form.hospitalId,
          openingDate: form.openingDate ? form.openingDate.valueOf() : null,
          address: form.address,
          
          productId: form.productId,
          productName: productList.value.find(p => p.key === form.productId)?.productName || '',
          price: form.price,
          priceExcludingVAT: form.priceExcludingVAT,
          priceIncludingVAT: form.priceIncludingVAT,
          discountRate: form.discountRate,
          productDescription: form.productDescription,
          
          contractStartDate: form.contractStartDate ? form.contractStartDate.valueOf() : null,
          contractEndDate: form.contractEndDate ? form.contractEndDate.valueOf() : null,
          managerName: form.managerName,
          managerContact: form.managerContact.replace(/-/g, ''),
          managerEmail: form.managerEmail,
          managerCompanyId: form.managerCompanyId,
          managerCompanyName: form.managerCompanyName,
          notes: form.notes,
          
          status: 'ACTIVE',
          cardInfos: cardInfos.value
        };
        
        // API 인스턴스 가져오기
        const api = salesRecordsApis(globalProperties?.$apiInstance, globalProperties?.$store);
        
        if (isEdit.value) {
          // 구독 수정
          await api.updateCenterflowSubscription(
            route.params.id,
            subscriptionData,
            (response) => {
              showToast('success', '구독 정보가 성공적으로 수정되었습니다.');
            },
            (error) => {
              showToast('error', error.response?.data?.message || '구독 정보 수정에 실패했습니다.');
            }
          );
        } else {
          // 구독 생성
          await api.createCenterflowSubscription(
            subscriptionData,
            (response) => {
              showToast('success', '구독이 성공적으로 등록되었습니다. 카드관리 에서 빌링키를 발급해주세요.');
              router.push('/salesrecords/centerflow-subscription');
            },
            (error) => {
              showToast('error', error.response?.data?.message || '구독 등록에 실패했습니다.');
            }
          );
        }
      } catch (error) {
        showToast('error', '구독 정보 처리 중 오류가 발생했습니다.');
      } finally {
        submitting.value = false;
      }
    };
    
    // 현입력 중인 카드 정보가 유효한지 확인
    const isValidCard = () => {
      return form.cardNumber && 
             form.cardExpiryMonth && 
             form.cardExpiryYear && 
             form.birthDate && 
             form.cardCompany;
    };
    
    // 수정 모드일 경우 데이터 로드
    const loadSubscription = async (id) => {
      try {
        const api = salesRecordsApis(globalProperties?.$apiInstance, globalProperties?.$store);
        
        await api.getCenterflowSubscription(
          id,
          (response) => {
            const subscription = response.data;
            
            // 구독자 정보
            form.hospitalId = subscription.hospitalId;
            form.hospitalName = subscription.hospitalName;
            form.hospitalType = subscription.hospitalType;
            
            // 사업자번호 설정 및 포맷팅 적용
            if (subscription.businessNumber) {
              form.businessNumber = subscription.businessNumber;
              formatBusinessNumber({ target: { value: form.businessNumber } });
            }
            
            form.openingDate = subscription.openingDate ? dayjs(subscription.openingDate) : null;
            form.address = subscription.address;
            
            // 상품 정보
            form.productId = subscription.productId;
            form.price = subscription.price;
            form.priceExcludingVAT = subscription.priceExcludingVAT;
            form.priceIncludingVAT = subscription.priceIncludingVAT;
            form.discountRate = subscription.discountRate;
            form.productDescription = subscription.productDescription;
            
            // 계약 정보
            form.contractStartDate = subscription.contractStartDate ? dayjs(subscription.contractStartDate) : null;
            form.contractEndDate = subscription.contractEndDate ? dayjs(subscription.contractEndDate) : null;
            form.managerName = subscription.managerName;
            form.managerCompanyId = subscription.managerCompanyId;
            form.managerCompanyName = subscription.managerCompanyName
            
            // 담당자 연락처 설정 및 포맷팅 적용
            if (subscription.managerContact) {
              form.managerContact = subscription.managerContact;
              formatMobileNumber({ target: { value: form.managerContact } });
            }
            
            form.managerEmail = subscription.managerEmail || '';
            form.notes = subscription.notes || '';
            
            // 카드 정보
            if (subscription.cardInfos && subscription.cardInfos.length > 0) {
              // 저장된 카드 목록 설정
              cardInfos.value = subscription.cardInfos.map(card => ({
                cardNumber: card.cardNumber,
                cardExpiry: card.cardExpiry,
                birthDate: card.birthDate,
                cardCompany: card.cardCompany,
                isDefault: card.isDefault,
                isActive: card.isActive,
                isVerified: card.isVerified,
                verifiedAt: card.verifiedAt
              }));
              
              // 현재 기본 카드 정보를 폼에 설정
              const defaultCard = subscription.cardInfos.find(card => card.isDefault) || subscription.cardInfos[0];
              
              // 카드번호 설정 및 포맷팅 적용
              if (defaultCard.cardNumber) {
                form.cardNumber = defaultCard.cardNumber;
                formatCardNumber({ target: { value: form.cardNumber } });
              }
              
              // 유효기간 분리 (MM/YY 형식)
              if (defaultCard.cardExpiry) {
                const [month, year] = defaultCard.cardExpiry.split('/');
                form.cardExpiryMonth = month;
                form.cardExpiryYear = year;
              }
              
              form.birthDate = defaultCard.birthDate;
              form.cardCompany = defaultCard.cardCompany;
              form.isDefaultCard = defaultCard.isDefault;
              form.isActiveCard = defaultCard.isActive;
            }
          },
          (error) => {
            showToast('error', '구독 정보를 불러오는데 실패했습니다.');
            router.push('/salesrecords/centerflow-subscription');
          }
        );
      } catch (error) {
        showToast('error', '구독 정보를 불러오는데 실패했습니다.');
        router.push('/salesrecords/centerflow-subscription');
      }
    };
    
    // 취소 핸들러
    const handleCancel = () => {
      router.push('/salesrecords/centerflow-subscription');
    };
    
    // 상품 관리 페이지로 이동 (상품 등록이 없을 때 사용)
    const navigateToProductManagement = () => {
      router.push('/salesrecords/products');
    };
    
    // 카드 유효성 검사 함수
    const validateCard = async () => {
      if (!form.cardNumber || !form.cardExpiryMonth || !form.cardExpiryYear || !form.birthDate) {
        showToast('error', '카드번호, 유효기간, 생년월일을 모두 입력해주세요.');
        return;
      }
      
      if (!form.businessNumber) {
        showToast('error', '사업자등록번호가 필요합니다. 먼저 병원 정보를 입력해주세요.');
        return;
      }
      
      validatingCard.value = true;
      
      try {
        // 카드 정보 형식 수정 - expiration 필드 사용
        const cardInfo = {
          cNo: form.businessNumber.replace(/-/g, ''),
          cardNo: form.cardNumber.replace(/-/g, ''),
          expiration: `${form.cardExpiryMonth}/${form.cardExpiryYear}`,
          identificationNo: form.birthDate
        };
        
        const api = salesRecordsApis(globalProperties?.$apiInstance, globalProperties?.$store);
        
        await api.checkCardValidity(
          cardInfo,
          (response) => {
            // 서버에서 응답받은 카드사 정보로 설정
            form.cardCompany = response.data;
            
            // 새로운 카드 정보 생성
            const newCardInfo = {
              cardNumber: form.cardNumber.replace(/-/g, ''),
              cardExpiry: `${form.cardExpiryMonth}/${form.cardExpiryYear}`,
              birthDate: form.birthDate,
              cardCompany: form.cardCompany,
              isDefault: true, // 항상 기본 카드로 설정
              isActive: true,  // 항상 활성 상태로 설정
              isVerified: true,
              verifiedAt: new Date()
            };
            
            // 기존 카드 정보를 모두 지우고 새 카드 정보만 저장
            cardInfos.value = [newCardInfo];
            
            showToast('success', `카드 유효성 검증에 성공했습니다. 카드사: ${response.data}`);
          },
          (error) => {
            showToast('error', error.response?.data?.message || '카드 유효성 검증에 실패했습니다.');
          }
        );
      } catch (error) {
        showToast('error', '카드 유효성 검증 중 오류가 발생했습니다.');
      } finally {
        validatingCard.value = false;
      }
    };
    
    // 제조사 검색 모달 상태
    const showManufacturerModal = ref(false);
    
    // 제조사 선택 핸들러
    const handleSelectManufacturer = (client) => {
      // 담당자 정보 설정
      
      // 제조사(회사) ID 설정
      form.managerCompanyId = client.id || client._id || '';
      form.managerCompanyName = client.name || '';
      
      if (client.accounts && client.accounts.length > 0) {
        // accounts 배열에서 첫 번째 계정 정보를 가져옵니다
        const accountInfo = client.accounts[0];
        
        // 담당자 이름
        form.managerName = accountInfo.name || '';
        
        // 담당자 연락처 설정
        if (accountInfo.mobile) {
          form.managerContact = accountInfo.mobile.replace(/-/g, '');
          formatMobileNumber({ target: { value: form.managerContact } });
        }
        
        // 담당자 이메일 설정
        form.managerEmail = accountInfo.email || '';
        
        showToast('success', '담당자 정보를 성공적으로 불러왔습니다.');
      } else if (client.empInfo) {
        // accounts가 없는 경우 기존 empInfo 사용
        // 담당자 이름
        form.managerName = client.empInfo.empName || '';
        
        // 담당자 연락처 설정 (포맷팅 함수가 적용됨)
        if (client.empInfo.empMobile) {
          form.managerContact = client.empInfo.empMobile.replace(/-/g, '');
          formatMobileNumber({ target: { value: form.managerContact } });
        }
        
        // 담당자 이메일 설정
        form.managerEmail = client.empInfo.empEmail || '';
        
        showToast('success', '담당자 정보를 불러왔습니다.');
      } else {
        showToast('warning', '담당자 정보를 찾을 수 없습니다.');
      }
      
      showManufacturerModal.value = false;
    };
    
    onMounted(() => {
      loadProductList();
      
      if (isEdit.value) {
        loadSubscription(route.params.id);
      }
    });
    
    return {
      formRef,
      form,
      rules,
      submitting,
      productList,
      isEdit,
      showSearchModal,
      validatingCard,
      cardInfos,
      handleProductChange,
      handleSubmit,
      handleCancel,
      navigateToProductManagement,
      formatCardNumber,
      formatBusinessNumber,
      formatBirthDate,
      formatMobileNumber,
      handleSelectClient,
      validateCard,
      isValidCard,
      showManufacturerModal,
      handleSelectManufacturer
    };
  }
};
</script>

<style scoped lang="scss">
.titleContainer {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.page-title {
  color: #000;
  font-size: 1.8rem;
}

.pageDesc {
  color: #6c757d;
  font-size: 14px;
  margin-top: 8px;
}

.form-card {
  padding: 24px;
  margin-bottom: 20px;
}

.form-section {
  margin-bottom: 28px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eaeaea;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;
}

.form-item {
  flex: 0 0 50%;
  padding: 0 12px;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    flex: 0 0 100%;
  }
}

.form-item-full {
  flex: 0 0 100%;
  padding: 0 12px;
  margin-bottom: 16px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.product-info {
  margin-top: 10px;
}

.card-expiry-container {
  display: flex;
  align-items: center;
}

.expiry-input {
  width: 60px;
  text-align: center;
}

.expiry-separator {
  margin: 0 8px;
  font-size: 18px;
}

.description-text {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 4px;
}

.optional-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-left: 8px;
  font-weight: normal;
}

:deep(.yellow-button) {
  background-color: #FFCC32 !important;
  border-color: #FFCC32 !important;
  color: #000 !important;
  
  &:hover {
    background-color: #E6B82E !important;
    border-color: #E6B82E !important;
  }
  
  &:disabled {
    background-color: #d9d9d9 !important;
    border-color: #d9d9d9 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
}

.input-with-button {
  display: flex;
  
  .ant-input {
    flex: 1;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  
  .search-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
    z-index: 1;
  }
}

.manager-section {
  margin-bottom: 20px;
}

.manager-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.manager-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin: 0;
}
</style> 